<template>
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <div class="login100-pic js-tilt" data-tilt>
                    <img src="/static/img/Blue-Yeti.png" alt="IMG" />
                </div>
                <div class="login100-form validate-form">
                    <div class="container-login100-form-btn">
                        <button class="login100-form-btn" type="submit" @click="authorize()">Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { UserManager, WebStorageStateStore } from 'oidc-client';
import authConfig from '../../../authConfig';

export default {
    data() {
        return {
            state: this.generateRandomString(),
        };
    },
    created() {
        let unAuthorized = this.$route.params.unAuthorized;
        if(unAuthorized){
            this.$notify({
                title: 'Unauthorized',
                message: "You don't have permission to perform this action. Please login again",
                type: 'error',
            });

        }
    },
    // mounted() {
    //     if (this.$route.query.loggedOut) {
    //         this.$notify({
    //             title: 'Success',
    //             message: 'You have successfully logged out.',
    //             type: 'success',
    //         });
    //     }
    // },
    methods: {
        generateRandomString() {
            return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        },
        authorize() {
            const userManager = new UserManager({
                userStore: new WebStorageStateStore({ store: window.localStorage }),
                ...authConfig,
            });
            userManager
                .signinRedirect({ state: this.state })
                .then(() => {
                    console.log('Successfull');
                })
                .catch((error) => {
                    console.log('OIDC Redirection Error:', error);
                });
        },
    },
};
</script>

<!-- Your styles here -->

<style scoped>
.extra-span {
    top: -38px;
}
.back-login {
    margin: 10px;
}
.textAlign {
    text-align: right;
}
</style>
<style>
#app {
    /*background: white !important;*/
    height: 100% !important;
}
.backgroundImage {
    /*background-image: url("http://keenthemes.com/metronic/preview/assets/app/media/img//bg/bg-4.jpg");*/
    background-attachment: fixed;
    background-size: cover;
    height: 800px;
}
.background-color-login {
    background-color: white;
    padding-top: 0px !important;
}
.wrap-login100 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.login100-pic {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login100-form {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-logo {
    text-align: center;
    margin: 60px;
}
/* -- body styles ------------------------------------- */
/* -- button styles ------------------------------------- */
/*-- signin-card animation ---------------------------------------- */
.signin-card {
    -webkit-animation: cardEnter 0.75s ease-in-out 0.5s;
    animation: cardEnter 0.75s ease-in-out 0.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    opacity: 0;
}
/* -- login paper styles ------------------------------ */
.signin-card {
    max-width: 350px;
    border-radius: 2px;
    margin: 20px auto;
    padding: 20px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.signin-card .logo-image,
.signin-card h1,
.signin-card p {
    text-align: center;
}
/* -- font styles ------------------------------------- */
.display1 {
    font-size: 28px;
    font-weight: 100;
    line-height: 1.2;
    color: #757575;
    text-transform: inherit;
    letter-spacing: inherit;
}
.subhead {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.1;
    color: #212121;
    text-transform: inherit;
    letter-spacing: inherit;
}
/* card animation from Animate.css -------------------- */
@-webkit-keyframes cardEnter {
    0%,
    20%,
    40%,
    60%,
    80%,
    100% {
        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        -ms-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    20% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1);
        -ms-transform: scale3d(1.1, 1.1, 1.1);
        transform: scale3d(1.1, 1.1, 1.1);
    }
    40% {
        -webkit-transform: scale3d(0.9, 0.9, 0.9);
        -ms-transform: scale3d(0.9, 0.9, 0.9);
        transform: scale3d(0.9, 0.9, 0.9);
    }
    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03, 1.03, 1.03);
        -ms-transform: scale3d(1.03, 1.03, 1.03);
        transform: scale3d(1.03, 1.03, 1.03);
    }
    80% {
        -webkit-transform: scale3d(0.97, 0.97, 0.97);
        -ms-transform: scale3d(0.97, 0.97, 0.97);
        transform: scale3d(0.97, 0.97, 0.97);
    }
    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
        -ms-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}
@keyframes cardEnter {
    0%,
    20%,
    40%,
    60%,
    80%,
    100% {
        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        -ms-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    20% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1);
        -ms-transform: scale3d(1.1, 1.1, 1.1);
        transform: scale3d(1.1, 1.1, 1.1);
    }
    40% {
        -webkit-transform: scale3d(0.9, 0.9, 0.9);
        -ms-transform: scale3d(0.9, 0.9, 0.9);
        transform: scale3d(0.9, 0.9, 0.9);
    }
    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03, 1.03, 1.03);
        -ms-transform: scale3d(1.03, 1.03, 1.03);
        transform: scale3d(1.03, 1.03, 1.03);
    }
    80% {
        -webkit-transform: scale3d(0.97, 0.97, 0.97);
        -ms-transform: scale3d(0.97, 0.97, 0.97);
        transform: scale3d(0.97, 0.97, 0.97);
    }
    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
        -ms-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}
button[disabled='disabled'],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// Login.vue?6302067b